'use client';

import { usePathname, useSearchParams } from 'next/navigation';

// /games/loopy-river/mathjams is embedded in mathjam.org's iframe, and /discord/* in Discord's activity iframes,
// where our consent banner never shows.
const NO_TRACKING_PATHS = ['/nms', '/games/loopy-river/mathjams', '/discord'];

/**
 * Returns true if the current page should not be tracked (no-marketing-shit paths or ?nms=true). Discord
 * serves each /discord/<game> at `/` (see next.config.mjs), so its `frame_id` param stands in for the path there.
 */
export function useNoTracking(): boolean {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  return (
    NO_TRACKING_PATHS.some((p) => pathname.startsWith(p)) ||
    searchParams.get('nms') === 'true' ||
    searchParams.has('frame_id')
  );
}
